module.exports = {"style":{"color":"white","backgroundColor":"black"},"children":"Damage","values":[1,2,3,4,5,6,7,8,9,10,11,12,13,14,15,16,17,18,19,20]}


//////////////////
// WEBPACK FOOTER
// ./src/components/Dice/damage.json
// module id = ./src/components/Dice/damage.json
// module chunks = 0